import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";
import { ApiUriContants } from '../_constants/apiUriConstants';

@Injectable({
    providedIn: "root"
})
export class TrackingService {
    constructor(private httpService: HttpService) { }
    KPIList(queryParams = {}) {
        const url = `${ApiUriContants.TrackingScreen}getfleetview`;
        return this.httpService.post(url, queryParams);
    }
    getPassagesData(vesselId: any, startDate: any, endDate: any) {
        const url = `${ApiUriContants.TrackingScreen}getpassagedata`;
        return this.httpService.get(url, { vesselId: vesselId, startDate: startDate, endDate: endDate });
    }
    getPassagesDataLatestReport(vesselId: any) {
        const url = `${ApiUriContants.TrackingScreen}getpassagedatalatestreport`;
        return this.httpService.get(url, { vesselId: vesselId });
    }

    GetPassageDataForChart(data: any) {
        const url = `${ApiUriContants.voyages}GetPassageDataForChart`;
        return this.httpService.post(url, data);
    }

    // Latest Poition to be displayed on map
    Getvesselpositions(data: any) {
        const url = `${ApiUriContants.voyages}getvesselpositions`;
        return this.httpService.post(url, data);
    }

    getVesselLatestPositions(id: any, vesselIds: any = null) {
        const url = `${ApiUriContants.voyages}getvessellatestpositions`;
        return this.httpService.post(url, { groupId: id, vesselIds });
    }

    // Close

    getecadata(params: any) {
        const url = `${ApiUriContants.voyages}getecadata`;
        return this.httpService.get(url, params);
    }
    deleteMeteoStratumData(params: any) {
        const url = `${ApiUriContants.voyages}deletemeteostratumdata`;
        return this.httpService.delete(url, params);
    }
    getMarineWeatherImage(params: any) {
        const url = `${ApiUriContants.voyages}getmarineweatherimage`;
        return this.httpService.get(url, params);
    }

    getMyVessels() {
        const url = `${ApiUriContants.TrackingScreen}getMyVessels`;
        return this.httpService.get(url);
    }

    KPIListByVessel(queryParams = {}) {
        const url = `${ApiUriContants.TrackingScreen}getfleetviewbyvessel`;
        return this.httpService.get(url, queryParams);
    }
    getPassageSummary(vesselId: any) {
        const url = `${ApiUriContants.TrackingScreen}getpassagesummary`;
        return this.httpService.get(url, { vesselId: vesselId });
    }
    getvesselcount(loginUserId: any) {
        const url = `${ApiUriContants.TrackingScreen}getallvesselgroupcount`;
        return this.httpService.get(url, loginUserId);
    }

    getProgressMetrics(vesselId: any) {
        const url = `${ApiUriContants.TrackingScreen}getProgressMetrics`;
        return this.httpService.get(url, { vesselId: vesselId });
    }
}
